import { useFacilityContext } from '@aspendental/shared-components-web';
import { Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import PhoneNumberLink from '@src/components/PhoneNumberLink';
import { FALLBACK_FACILITY_PHONE_NUMBER } from '@src/constants';

export default function FurtherAssistanceContact({ directAction = false }: { directAction?: boolean }) {
	const theme = useTheme();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
	const facilityDetails = useFacilityContext();
	const { officeInfo } = facilityDetails;
	const localFacilityNumber = officeInfo?.technicalInfrastructure?.phoneNumber ?? FALLBACK_FACILITY_PHONE_NUMBER;
	const { t } = useTranslation('furtherAssistanceContact');

	const fontVariant = isSmallScreen ? 'bodyMediumBook' : 'bodyLargeBook';

	if (directAction) {
		return (
			<Typography variant={fontVariant} color="primary.main" data-test-id="text_further_assistance">
				{t('directAction1')} <PhoneNumberLink phoneNumber={localFacilityNumber} variant={fontVariant} />{' '}
				{t('directAction2')}
			</Typography>
		);
	}

	return (
		<Typography variant={fontVariant} color="primary.main" data-test-id="text_further_assistance">
			{t('indirectAction')} <PhoneNumberLink phoneNumber={localFacilityNumber} variant={fontVariant} />
		</Typography>
	);
}
